import { useEffect, useState } from 'react';
import useCriticalAssets from '@elementary/common-ui/hooks/useCriticalAssets';

const useCriticalAsset = (isCriticalAssetsIds: string[]) => {
  const [internalIsCritical, setInternalIsCritical] = useState(false);
  const [isCriticalSaving, setIsCriticalSaving] = useState(false);

  const {
    criticalAssetsData,
    setIsCriticalAssets,
    hasSetPermissions: hasSetCriticalAssetsPermissions,
  } = useCriticalAssets(
    isCriticalAssetsIds.length ? { ids: isCriticalAssetsIds } : {},
  );
  const { data: criticalData, isLoading: isCriticalAssetsLoading } =
    criticalAssetsData;
  const { setIsCriticalAssetsMutationAsync } = setIsCriticalAssets;

  useEffect(() => {
    setInternalIsCritical(criticalData?.[0]?.isCritical || false);
  }, [criticalData]);

  const handleCriticalChange = async (value: string) => {
    const newValue = value === 'critical';
    const previousValue = internalIsCritical;
    setInternalIsCritical(newValue);
    setIsCriticalSaving(true);
    try {
      await setIsCriticalAssetsMutationAsync({
        assetsIds: isCriticalAssetsIds,
        isCriticalValue: newValue,
      });
    } catch {
      setInternalIsCritical(previousValue);
    }
    setIsCriticalSaving(false);
  };

  return {
    internalIsCritical,
    handleCriticalChange,
    isCriticalSaving,
    isCriticalAssetsLoading,
    hasSetCriticalAssetsPermissions,
  };
};

export default useCriticalAsset;
